import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const DataTableShell = ({ children, isLoading = false, emptyMessage, errorMessage }) => {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-2 shadow-sm">
      {errorMessage ? (
        <div className="px-2 py-3">
          <p className="text-sm text-red-600">{errorMessage}</p>
        </div>
      ) : null}
      {isLoading ? (
        <div className="flex flex-col gap-3 px-2 py-1">
          <div className="space-y-3">
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-full" />
          </div>
          <div className="space-y-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} className="h-3 w-full" />
            ))}
          </div>
        </div>
      ) : null}
      {!isLoading && !errorMessage && emptyMessage ? (
        <div className="px-2 py-3">
          <p className="text-sm text-slate-500">{emptyMessage}</p>
        </div>
      ) : null}
      {children}
    </div>
  );
};

export default DataTableShell;
